export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9244.ff012cc0.jpg";